import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\src\\app\\error.tsx");
